import { Box, IconButton, Text } from '@nimbus-ds/components';
import {
  EditIcon,
  EyeIcon,
  EyeOffIcon,
  RedoIcon,
  TrashIcon,
} from '@nimbus-ds/icons';
import { SavedSearchInterface } from 'domains/Orders/Orders';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface SavedSearchItemProps {
  savedSearch: SavedSearchInterface;
  onSavedSearchChange: (ss: SavedSearchInterface) => void;
  onSavedSearchEdit: (ss: SavedSearchInterface) => void;
}

export function SavedSearchItem({
  savedSearch,
  onSavedSearchChange,
  onSavedSearchEdit,
}: Readonly<SavedSearchItemProps>) {
  const t = useTranslationOrders('savedSearches');

  const handleHiddenChange = () => {
    onSavedSearchChange({
      ...savedSearch,
      hidden: !savedSearch.hidden,
    });
  };

  const handleDeleteChange = () => {
    onSavedSearchChange({
      ...savedSearch,
      deleted: !savedSearch.deleted,
    });
  };

  const handleEdit = () => {
    onSavedSearchEdit(savedSearch);
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      gap="1"
      alignItems="center"
    >
      <Text>
        {savedSearch.isDefault
          ? t(`default.${savedSearch.key}`)
          : savedSearch.name}
      </Text>
      <Box display="flex" flexDirection="row" gap="2">
        <IconButton
          onClick={handleHiddenChange}
          size="2rem"
          source={savedSearch.hidden ? <EyeOffIcon /> : <EyeIcon />}
        />
        {!savedSearch.isDefault && (
          <>
            <IconButton
              onClick={handleEdit}
              size="2rem"
              source={<EditIcon />}
            />
            <IconButton
              onClick={handleDeleteChange}
              size="2rem"
              source={savedSearch.deleted ? <RedoIcon /> : <TrashIcon />}
            />
          </>
        )}
      </Box>
    </Box>
  );
}
